import { http } from "../client";
export var changeDeviceVolume = function (_a) {
    var id = _a.id, volume = _a.volume;
    return http.api.post("devices/" + id + "/volume/" + volume, { volume: volume });
};
